"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _count = _interopRequireDefault(require("../poly/count"));
var _map = _interopRequireDefault(require("../poly/map"));
var _keys = _interopRequireDefault(require("../poly/keys"));
var _reduce = _interopRequireDefault(require("../poly/reduce"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactFlatten = _interopRequireDefault(require("../poly/reactFlatten"));
var _excluded = ["classes", "children", "cols", "center", "scrollOn", "className", "reverse", "featureFirst", "gridRepeat"];
var BREAKPOINTS = ['xl', 'lg', 'md', 'sm', 'xs'];
var getScrollOnStyles = function getScrollOnStyles(theme, scrollOn, callback) {
  return BREAKPOINTS.slice(BREAKPOINTS.indexOf(scrollOn)).reduce(function (styles, breakpoint) {
    return (0, _extends4.default)({}, styles, (0, _defineProperty2.default)({}, theme.breakpoints.only(breakpoint), callback(breakpoint)));
  }, {});
};
var getColsStyles = function getColsStyles(theme, callback, cols) {
  return (0, _pipe.default)(_keys.default, (0, _reduce.default)(function (styles, breakpoint) {
    return (0, _extends4.default)({}, styles, (0, _defineProperty2.default)({}, theme.breakpoints.up(breakpoint), callback(breakpoint)));
  }, {}))(cols);
};
var useClasses = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(_ref) {
      var cols = _ref.cols,
        numItems = _ref.numItems,
        center = _ref.center,
        gap = _ref.gap,
        gridRepeat = _ref.gridRepeat;
      var rootStyle = {
        display: 'grid',
        width: '100%',
        gridGap: theme.spacing(3.75)
      };
      if ((0, _isObject.default)(cols)) {
        rootStyle = (0, _extends4.default)({}, rootStyle, getColsStyles(theme, function (breakpoint) {
          return {
            gridTemplateColumns: cols[breakpoint] > numItems && center ? "repeat(".concat(numItems, ", ").concat(gridRepeat, ")") : "repeat(".concat(cols[breakpoint], ", ").concat(gridRepeat, ")")
          };
        }, cols));
      } else {
        rootStyle = (0, _extends4.default)({}, rootStyle, {
          gridTemplateColumns: cols > numItems && center ? "repeat(".concat(numItems, ", ").concat(gridRepeat, ")") : "repeat(".concat(cols, ", ").concat(gridRepeat, ")")
        });
      }
      return rootStyle;
    },
    featuredItem: function featuredItem(_ref2) {
      var cols = _ref2.cols;
      var baseStyle = {
        gridColumnStart: 1
      };
      if ((0, _isObject.default)(cols)) {
        return (0, _extends4.default)({}, baseStyle, getColsStyles(theme, function (breakpoint) {
          return {
            gridColumnEnd: cols[breakpoint] + 1
          };
        }, cols));
      }
      return (0, _extends4.default)({}, baseStyle, {
        gridColumnEnd: cols + 1
      });
    },
    scrollRoot: function scrollRoot(_ref3) {
      var scrollOn = _ref3.scrollOn;
      return (0, _extends4.default)({
        display: 'flex',
        width: '100vw',
        flexWrap: 'nowrap',
        overflowX: 'scroll',
        scrollSnapType: 'x mandatory'
      }, getScrollOnStyles(theme, scrollOn, function (breakpoint) {
        return {
          marginLeft: "-".concat(theme.gutters.page[breakpoint]),
          marginRight: "-".concat(theme.gutters.page[breakpoint]),
          paddingLeft: theme.gutters.page[breakpoint]
        };
      }));
    },
    itemContainer: function itemContainer(_ref4) {
      var scrollOn = _ref4.scrollOn;
      return (0, _extends4.default)({
        minWidth: '80vw',
        scrollSnapAlign: 'center'
      }, getScrollOnStyles(theme, scrollOn, function (breakpoint) {
        return {
          paddingRight: theme.gutters.page[breakpoint]
        };
      }));
    }
  };
}, {
  classNamePrefix: 'TCUIGrid'
});
var Grid = function Grid(_ref5) {
  var classes = _ref5.classes,
    children = _ref5.children,
    cols = _ref5.cols,
    center = _ref5.center,
    scrollOn = _ref5.scrollOn,
    className = _ref5.className,
    reverse = _ref5.reverse,
    featureFirst = _ref5.featureFirst,
    gridRepeat = _ref5.gridRepeat,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded);
  var _children = reverse ? (0, _reactFlatten.default)(children).reverse() : (0, _reactFlatten.default)(children);
  var numItems = (0, _count.default)(_children);
  var theme = (0, _styles.useTheme)();
  var shouldScroll = (0, _core.useMediaQuery)(theme.breakpoints.down(scrollOn));
  var _classes = useClasses({
    cols: cols,
    numItems: numItems,
    scrollOn: scrollOn,
    center: center,
    gridRepeat: gridRepeat
  });
  if (scrollOn && shouldScroll && numItems > 1) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({}, rest, {
      className: (0, _clsx.default)(_classes.scrollRoot, className, classes.root)
    }), (0, _map.default)(function (child, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "grid-item-".concat(index + 1),
        className: (0, _clsx.default)(_classes.itemContainer, classes.itemContainer)
      }, child);
    }, _children));
  }
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({}, rest, {
    className: (0, _clsx.default)(_classes.root, className, classes.root)
  }), (0, _map.default)(function (child, index) {
    return index === 0 && featureFirst ? /*#__PURE__*/_react.default.createElement("div", {
      key: "grid-item-".concat(index + 1),
      className: (0, _clsx.default)(_classes.featuredItem, classes.featuredItem)
    }, child) : child;
  }, _children));
};
Grid.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    itemContainer: _propTypes.default.string,
    featuredItem: _propTypes.default.string
  }),
  cols: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    xs: _propTypes.default.number,
    sm: _propTypes.default.number,
    md: _propTypes.default.number,
    lg: _propTypes.default.number,
    xl: _propTypes.default.number
  })]),
  center: _propTypes.default.bool,
  scrollOn: _propTypes.default.oneOf(BREAKPOINTS),
  className: _propTypes.default.string,
  reverse: _propTypes.default.bool,
  featureFirst: _propTypes.default.bool,
  gridRepeat: _propTypes.default.string
};
Grid.defaultProps = {
  scrollOn: null,
  children: null,
  classes: {},
  cols: 2,
  center: false,
  className: null,
  reverse: false,
  featureFirst: false,
  gridRepeat: '1fr'
};
var _default = Grid;
exports.default = _default;